(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/authenticate/assets/javascripts/utils/utils.js') >= 0) return;  svs.modules.push('/components/accountservices/authenticate/assets/javascripts/utils/utils.js');

'use strict';

function parseISOString(isoString) {
  if (isoString) {
    const dateComp = isoString.split(/\D+/);

    if (dateComp.length === 7) {
      dateComp[3] = dateComp[3] - dateComp[6] / 100;
      return new Date(Date.UTC(dateComp[0], --dateComp[1], dateComp[2], dateComp[3], dateComp[4], dateComp[5], dateComp[6]));
    }
  }
}
svs.accountservices.authenticate.utils.parseISOString = parseISOString;

 })(window);